import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ApplicationStoreService } from '../services/application-store.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationResetResolver  {

  constructor(
    private store: ApplicationStoreService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.store.resetApplication();
    return of(true);
  }
}
